export default __webpack_public_path__ + "static/media/emoji-tick.b193efbd.svg";